module.exports = __webpack_public_path__ + "img/live2.e9ae063d.png";